import { render, staticRenderFns } from "./CvResult.vue?vue&type=template&id=225485a9&scoped=true&"
import script from "./CvResult.vue?vue&type=script&lang=ts&"
export * from "./CvResult.vue?vue&type=script&lang=ts&"
import style0 from "./CvResult.vue?vue&type=style&index=0&id=225485a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225485a9",
  null
  
)

export default component.exports